// 9034: an hourly service tariff bills its minimum, then the time beyond it
// rounded up to the billing increment. Mirrors backend servicePricing.js so the
// tariff form can show what a job would be billed.

const round = (n) => Math.round(Number(n) * 100) / 100;

export const BILLING_INCREMENTS = [15, 30, 60];

export function billableHours(actualHours, { minHours = 0, incrementMinutes = null } = {}) {
  const min = Math.max(0, Number(minHours) || 0);
  const actual = Math.max(0, Number(actualHours) || 0);
  const inc = Number(incrementMinutes) > 0 ? Number(incrementMinutes) : null;
  if (!inc) return round(Math.max(actual, min));
  const actualMin = Math.round(actual * 60);
  const minMin = Math.round(min * 60);
  if (actualMin <= minMin) return round(min);
  return round((minMin + Math.ceil((actualMin - minMin) / inc) * inc) / 60);
}

/** "min 1h, 30-min increments" */
export function billingRuleText({ minHours = 0, incrementMinutes = null } = {}) {
  const parts = [];
  if (Number(minHours) > 0) parts.push(`min ${round(minHours)}h`);
  if (Number(incrementMinutes) > 0) parts.push(`${Number(incrementMinutes)}-min increments`);
  return parts.join(', ') || 'actual time';
}

/** "2h 10m" */
export function formatDuration(minutes) {
  const total = Math.max(0, Math.round(Number(minutes) || 0));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (!h) return `${m}m`;
  return m ? `${h}h ${m}m` : `${h}h`;
}
